<template>
<div class="page_">
    <a-table 
        style="margin: 0 auto;width:476px;" 
        :columns="columns" 
        :dataSource="tableData"
        :pagination="false"
        class="table_1"
    >
      <span slot="type" slot-scope="text, record" class="span_btn">
            <span>{{text | filterIdType(idTypeOptions) }}</span>
      </span>
    </a-table>
</div>
</template>
<style lang="scss" scoped>

</style>
<script>
import navbar from '../components/navbar'
import api from '@/utils/api'
const columns = [{
    title: '证件类型',
    key: 'type',
    dataIndex: 'type',
    scopedSlots: { customRender: "type" }
}, {
    title: '证件号码',
    key: 'idNumber',
    dataIndex: 'idNumber'
}]

export default {
    data () {
        document.title = '已绑定证件'
        return {
            columns,
            tableData: [],
            idTypeOptions: [
              {
                name: "身份证",
                value: "1"
              },
              {
                name: "护照",
                value: "2"
              },
              {
                name: "台湾通行证",
                value: "6"
              },
              {
                name: "港澳通行证",
                value: "4"
              },
            ],
        }
    },
    filters: {
      filterIdType: (val, idTypeOptions) => {
        if (!val) {
          return ''
        } else {
          let idName = ''
          idTypeOptions.map(item => {
            if(item.value == val){
              idName = item.name
            }
          })
          return idName
        }
      },
    },
    components: {
        navbar
    },
    mounted(){
      this.fetchData()
    },
    methods: {
       fetchData(){
         api.getCertificateInfo().then(res => res.data).then(data => {
            if(data.returnCode==='0000'){
                this.tableData=data.data
              }
          })
       } 
    }
}
</script>